<app-auth-shell title="Bem-vindo!" subtitle="Entre para continuar">
  <form role="form" [formGroup]="formSignin" (ngSubmit)="signin()">
    <div class="auth-field">
      <label class="auth-field__label" for="email">E-mail</label>
      <div class="auth-field__control">
        <input
          id="email"
          type="email"
          formControlName="email"
          class="auth-field__input"
          placeholder="nome@empresa.com"
          autocomplete="email"
          appFocus
        />
      </div>
      @if (formSignin.get('email')?.touched || formSignin.get('email')?.dirty) {
        @if (formSignin.get('email')?.hasError('required')) {
          <div class="auth-field__error">Campo obrigatório</div>
        }
        @if (formSignin.get('email')?.hasError('email')) {
          <div class="auth-field__error">E-mail inválido</div>
        }
      }
    </div>
    <div class="auth-field">
      <label class="auth-field__label" for="password">Senha</label>
      <div class="auth-field__control">
        <input
          id="password"
          type="password"
          formControlName="password"
          class="auth-field__input auth-field__input--toggle"
          placeholder="Sua senha"
          autocomplete="current-password"
        />
        <button type="button" class="auth-field__toggle" appShow aria-label="Mostrar senha">
          <span><i class="fas fa-eye"></i></span>
        </button>
      </div>
      @if (formSignin.get('password')?.touched || formSignin.get('password')?.dirty) {
        @if (formSignin.get('password')?.hasError('required')) {
          <div class="auth-field__error">Campo obrigatório</div>
        }
      }
    </div>
    <div class="auth-field__action">
      <a class="auth-link" [routerLink]="['/forgot']">Esqueceu a senha?</a>
    </div>
    <button type="submit" class="auth-btn" [disabled]="!formSignin.valid">Entrar</button>
  </form>
  <div class="auth-methods">
    <a class="auth-link" [routerLink]="['/magic-link']">Entrar com link no e-mail</a>
    <a class="auth-link" [routerLink]="['/otp']">Entrar com código no e-mail</a>
    <a class="auth-link" [routerLink]="['/whatsapp']">Entrar com código no WhatsApp</a>
  </div>
  <div class="auth-divider">ou continue com</div>
  <div class="auth-social">
    <div class="social-login-btn">
      <button type="button" class="auth-social__btn social-login-btn__visible" tabindex="-1" aria-hidden="true">
        <i class="fab fa-google auth-social__google"></i>
        Google
      </button>
      <div id="google-btn-container" class="social-login-btn__overlay" aria-label="Entrar com Google"></div>
    </div>
    <button type="button" class="auth-social__btn" (click)="loginWithFacebook()">
      <i class="fab fa-facebook-f auth-social__facebook"></i>
      Facebook
    </button>
  </div>
  <div class="auth-shell__links">
    <p class="auth-shell__links-text">
      Não tem uma conta?
      <a class="auth-link" [routerLink]="['/signup']">Cadastre-se</a>
    </p>
    <p class="auth-shell__legal">
      <a [routerLink]="['/termos']">Termos de Uso</a>
      ·
      <a [routerLink]="['/privacidade']">Política de Privacidade</a>
    </p>
  </div>
</app-auth-shell>
